<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 22 22"
		role="presentation"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill="currentColor"
			d="M20.380114,0.315691918 C20.7399219,0.0307685827 21.2504148,0.0287899484 21.6123155,0.309756015 L21.7071068,0.393398282 L21.7848131,0.480619095 C22.0697365,0.840426946 22.0717151,1.35091991 21.790749,1.71282061 L21.7071068,1.80761184 L12.5147186,11 L21.7071068,20.1923882 L21.7848131,20.279609 C22.0956386,20.6721266 22.0697365,21.243972 21.7071068,21.6066017 C21.3466228,21.9670857 20.7793918,21.9948152 20.3871006,21.6897903 L20.2928932,21.6066017 L11,12.3135051 L1.70710678,21.6066017 C1.31658249,21.997126 0.683417511,21.997126 0.292893219,21.6066017 C-0.0697364807,21.243972 -0.0956386021,20.6721266 0.215186855,20.279609 L0.292893219,20.1923882 L9.48528137,11 L0.292893219,1.80761184 C-0.0697364807,1.44498215 -0.0956386021,0.873136751 0.215186855,0.480619095 L0.292893219,0.393398282 C0.655522918,0.0307685827 1.22736831,0.00486646133 1.61988597,0.315691918 L1.70710678,0.393398282 L11,9.68550506 L20.2928932,0.393398282 L20.380114,0.315691918 Z"
			id="Path"
		></path>
	</svg>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: "",
		},
		width: {
			type: Number,
			default: 22,
		},
		height: {
			type: Number,
			default: 22,
		},
		fill: {
			type: String,
			default: "#000",
		},
	},
};
</script>

<style scoped>
path {
	transition: all 0.3s;
}
</style>
